import { render } from "./SidebarNav.vue?vue&type=template&id=3323059a&scoped=true&lang=pug"
import script from "./SidebarNav.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarNav.vue?vue&type=script&setup=true&lang=js"

import "./SidebarNav.vue?vue&type=style&index=0&id=3323059a&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3323059a"]])

export default __exports__